<template>

  <Dialog v-model:visible="visible"
    :style="{ width: '600px', maxHeight: '90wh' }"
    :modal="true"
    :contentStyle="{'overflow': 'visible'}"
    ref="dialog"
    @show="onShow"
    @hide="onHide"
    >
    <template #header>
      <h2>{{title}}</h2>
    </template>

    <div class="p-fluid p-grid">
      <div class="p-field p-col-12 p-md-3 p-input-filled">
        <label for="number">Продуктов номер</label>
        <InputText :tabindex="-1" id="code" type="text" v-model="productNumber" readonly="true"/>
      </div>
      <div class="p-field p-col-12 p-md-9">
        <label for="name">Наименование</label>
        <AutoComplete v-model="product" :dropdown="true" field="name"
          :suggestions="products" @complete="searchProduct($event)" forceSelection
            placeholder="Въведете продуктов номер или наименование" @itemSelect="onProductSelect">
            <template #item="props">
              {{props.item.number}} {{props.item.name}}
            </template>
        </AutoComplete>
      </div>
      <div class="p-field p-col-12 p-md-9">
        <label for="name">Партида</label>
        <AutoComplete v-model="data.batch" :dropdown="true" field="name"
          :suggestions="deliveries" @complete="searchDelivery($event)" forceSelection
            placeholder="Въведете партида">
            <template #item="props">
              <span>{{props.item.name}}</span>
                /
                &nbsp;<Badge class="p-overlay-badge" :value="props.item.quantity"/>
            </template>
        </AutoComplete>
      </div>
      <div class="p-field p-col-12 p-md-3 p-input-filled">
        <label for="availability">Наличност</label>
        <InputText v-model="availability" readonly/>
      </div>
      <div class="p-field p-col-12 p-md-4">
        <label for="quantity">Количество</label>
        <InputNumber ref="quantity" id="quantity" v-model="data.quantity" :minFractionDigits="1" :maxFractionDigits="4" :format="true"/>
      </div>
      <div class="p-field p-col-12 p-md-4">
        <label for="price">Ед. цена</label>
        <InputNumber ref="price" id="price" v-model="data.price" :minFractionDigits="2" :maxFractionDigits="4" :format="true"/>
      </div>
      <div class="p-field p-col-12 p-md-4">
        <label for="discountPerc">ТО %</label>
        <InputNumber tabindex="-1" id="discountPerc" v-model="data.discountPerc"/>
      </div>
    </div>

    <template #footer>
      <ButtonsApplyCancel @apply="onSave" @cancel="$refs.dialog.close()"/>
    </template>
  </Dialog>

</template>

<script>

export default {
  emits: {
    load: null,
    save: null,
    calculate: null
  },
  data() {
    return {
      visible: false,
      selected: {},
      tabIndex: 0,
      products: [],
      deliveries: [],
      data: {
      }
    }
  },

  mounted() {
  },

  props: {
    title: String,
    hasVat : Boolean
  },

  methods: {
    searchProduct(event) {
      var ctx = this;
      this.$http.get('/product', {
        params: {
          query: event.query
        }
      }).then(res => ctx.products = res.data)
    },
    searchDelivery() {
      var ctx = this;
      if(this.data.product && this.data.product.id) {
        this.$http.get('/sale/items-available', {
          params: {
              product: this.data.product.id,
              store: this.sale.store.id,
              date: this.sale.date
          }
        }).then(res => ctx.deliveries = res.data)
      }
    },
    onShow() {
      var data = {};
      this.$emit('load', data);
      this.sale = data.sale;
      this.data = data.data;
      data.quantity = this.$utils.value(data.quantity);
      if (data.quantity == 0) {
        data.quantity = undefined;
      }
      data.price = this.$utils.value(data.price);
      if (data.price == 0) {
        data.price = undefined;
      }
      if (data.discountPerc == 0) {
        data.discountPerc = undefined;
      }
    },
    onHide() {
      this.data = {}
    },
    onSave() {
      this.$emit('save', this.data);
      this.$refs.dialog.close();
    },
    onProductSelect() {
    }
  },

  computed: {
    productNumber: function() {
      if (this.data.product) {
        return this.data.product.number;
      }
      return "";
    },
    productName: function() {
      if (this.data.product) {
        return this.data.product.name;
      }
      return "";
    },
    product: {
      get() {
        return this.data.product;
      },
      set(product) {
        var data = this.data;
        data.product = product;
        data.quantity = 1;
        data.batch = null;
        data.price = 0;
        this.deliveries = [];
        if(product && (typeof product) === 'object') {
          data.price = this.$utils.value(product.priceRetail);
        }
        this.$emit('calculate', data);
      }
    },
    availability() {
      if (this.data.batch) {
        return this.data.batch.quantity;
      }
      return null;
    },
  }
}
</script>

<style>

</style>
